import _ from 'lodash';
import React from 'react';
import { VerifiedCheck } from '../../../static/svg/VerifiedCheck';
import { ReviewType } from '../../components/libs/typeInterface';

interface IProductReviews {
  rating: number;
  reviews: ReviewType[];
  verifiedUser: number;
  link: string;
}
const ProductReviews = (props: IProductReviews) => {
  const { rating, reviews, verifiedUser, link } = props;
  return (
    <>
      <div className="w-full flex flex-col">
        <div className="w-full flex flex-row justify-start items-center xs:flex-wrap lg:flex-nowrap xs:py-4 lg:py-6 border-b border-borderColor xs:space-y-5 lg:space-y-0 lg:space-x-5">
          <div className="xs:w-full lg:w-auto flex flex-row justify-start px-4 space-x-5 lg:border-r lg:border-borderColor">
            <p className="text-4xl font-bold">
              {rating}
              <span className="font-medium">/5</span>
            </p>
            <p className="text-sm">
              <span className="font-semibold">{verifiedUser}</span> verified <br />
              user ratings
            </p>
          </div>
          <div className="flex-1 flex items-center justify-start">
            <a
              target="_blank"
              href={link + '/#product-review-container'}
              className="cursor-pointe px-8 py-2 text-customColors-300 xs:text-sm lg:text-base text-center rounded-sm z-10 transition-all duration-300 shop-now shade-0"
            >
              Write a Review
            </a>
          </div>
        </div>
        <div className="w-full flex flex-col items-start justify-start space-y-4">
          {reviews.map((item: ReviewType, index: number) => (
            <div
              key={index}
              className="w-full flex xs:flex-wrap lg:flex-nowrap flex-row justify-start items-start py-4 border-b border-borderColor xs:space-y-4 lg:space-y-0 lg:space-x-8"
            >
              <div className="xs:w-full lg:w-1/5 flex flex-row">
                <div className="w-10 h-10 flex items-center justify-center">
                  <img
                    src="/images/review-user-mask.png"
                    alt="review-user-mask"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="flex-1 ml-4 flex xs:flex-row lg:flex-col">
                  <div className="w-full flex flex-col">
                    <p className="font-semibold">{item.name || 'unknown'}</p>
                    {item.isVerified && (
                      <p className="flex flex-row justify-start text-xs">
                        <VerifiedCheck className="mr-1" /> Verified user
                      </p>
                    )}
                  </div>
                  <div className="w-full flex flex-col justify-between items-end lg:hidden">
                    {item.userRating > 0 && (
                      <p className="flex flex-row items-center justify-start space-x-2">
                        {_.times(item.userRating, (i: number) => (
                          <img
                            src="/images/RatingStar.svg"
                            alt="rating-star"
                            className="w-4"
                            key={i}
                          />
                        ))}
                      </p>
                    )}
                    <p className="text-sm text-secondary">{item.date}</p>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex flex-col">
                <p className="w-full font-semibold">&quot;{item.title}&quot;</p>
                <div
                  className="w-full space-y-2"
                  dangerouslySetInnerHTML={{ __html: item.reviewText || '' }}
                />
              </div>
              <div className="xs:hidden lg:w-1/5 lg:flex flex-col">
                <div className="w-full lg:flex flex-row justify-between">
                  <p className="flex flex-row items-center justify-start space-x-2">
                    {_.times(item.userRating, (i: number) => (
                      <img src="/images/RatingStar.svg" alt="rating-star" className="w-4" key={i} />
                    ))}
                  </p>
                  <p className="text-sm text-secondary">{item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductReviews;
